import { render, staticRenderFns } from "./BrowseGoalsPage.vue?vue&type=template&id=0c99fd48&scoped=true"
import script from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsPage.vue?vue&type=style&index=0&id=0c99fd48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99fd48",
  null
  
)

export default component.exports